import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CustomToast from "../../components/misc/CustomToast";
import { useIsMobile } from "../../hooks/useIsMobile";
import { cn } from "../../utils/classMerger";
import SendSettingsCard from "./SendSettingsCard";
import RunsTable from "./RunsTable";
import { getWeeklySummaryRuns } from "./actions";
import { WeeklySummaryRun } from "./types";

const WeeklySummary: React.FC = () => {
    const mobile = useIsMobile(900);
    const [runs, setRuns] = useState<WeeklySummaryRun[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await getWeeklySummaryRuns(12);
                if (!cancelled) setRuns(data);
            } catch {
                if (!cancelled) {
                    toast.error(<CustomToast message="Failed to load weekly summary runs" type="error" />, { autoClose: 3000 });
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className={mobile ? "p-4" : "p-6"}>
            <div className="grid items-start gap-8">
                <div className="grid gap-1 px-2">
                    <h1 className={cn("font-bold tracking-tight text-primary", mobile ? "text-2xl" : "text-3xl")}>
                        Weekly Summary
                    </h1>
                    <p className="text-gray-500">
                        The weekly activity email every subscribed user receives. Change when it goes out and check each run.
                    </p>
                </div>
                <SendSettingsCard />
                <RunsTable runs={runs} loading={loading} />
            </div>
        </div>
    );
};

export default WeeklySummary;
